// extracted by mini-css-extract-plugin
export default {"wrap":"NormalPdf_wrap__mOhXi","page":"NormalPdf_page__weKQc"};